'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {getRouter} from '../../../config/reducers/state';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const navState$ = state$
    .map(getRouter)
    .distinctUntilChanged();

  return props$
    .combineLatest(
      navState$,
      (props, navState) => ({
        ...props,
        navState,
      }));
};

export const NavigationBarContainer = fuse(StreamedComponent);



// WEBPACK FOOTER //
// ./src/js/components/views/NavigationBar/NavigationBarContainer.js